import { useSuspenseQuery } from '@tanstack/react-query';
import { usersQueries } from '@repo/api-kit/queries/users';

export function useCurrentUser() {
  const queryResult = useSuspenseQuery(usersQueries.getMe());

  return queryResult;
}
